import * as React from "react";
import { ApiSelectedFixedComment, SelectedFixedCommentMeta, SelectedFixedComment } from "../../../../misc/api/FixedComments/apiTypes";
import { forEach, keys, map, first } from "lodash";
import { Form } from "informed";
import Modal from "../../../../misc/components/modal";
import FixedCommentInput from "./FixedCommentInput";
import Loading from "../../../../misc/components/loading";
import Alert, { AlertCategoryEnum } from "../../../../misc/components/Alert";
import { ModelError } from "../../../../misc/api/apiTypes";
import { FixedComment } from "webportalclient";

interface AsyncFixedCommentsProps {
    commentMetadata: SelectedFixedCommentMeta[];
    updateComments?: (commentMutations: ApiSelectedFixedComment[]) => Promise<void>;
    onClose: () => void;
    header: string;
}

function mapToFormState(values: FixedComment[]): TechnicianTestFixedCommentsFormProps {
    var formState = {};

    forEach(values, c => formState[c.id] = c);

    return formState;
}

function mapToApi(formValues: TechnicianTestFixedCommentsFormProps): ApiSelectedFixedComment[] {
    return map(formValues, (v, k) => {

        return {
            ...v,
            Id: k
        };
    });
}

interface TechnicianTestFixedCommentsFormProps {
    [key: string]: SelectedFixedComment;
};

const AsyncFixedComments = ({commentMetadata, updateComments, onClose, header }: AsyncFixedCommentsProps): JSX.Element => {
    const [isBusy, setIsBusy] = React.useState<boolean>(false);
    const [errors, setErrors] = React.useState<ModelError[]>([]);

    const handleSubmit = async (formState: TechnicianTestFixedCommentsFormProps) => {
        setIsBusy(true);
        setErrors([]);
        try {
            await updateComments(mapToApi(formState));
            setIsBusy(false);
            onClose && onClose();
        } catch (error) {
            setIsBusy(false);
            setErrors([error]);
        }
    };

    return (commentMetadata ? <Form<TechnicianTestFixedCommentsFormProps> initialValues={mapToFormState(commentMetadata)} onSubmit={handleSubmit}>
        {({ formState, formApi }) => (
            <Modal header={header} show={true} closeModalHandler={(isBusy || !keys(formState.touched)?.length) ? onClose : null}>
                <Alert show={!!first(errors)} category={AlertCategoryEnum.Danger} >
                    <ul>
                        {map(errors, (err, index) => <li key={index}>{err.Message}</li>)}
                    </ul>
                </Alert>
                <div className="modal-body">
                    <div className="row">
                        <div className="col-md-12">
                            {commentMetadata?.map(cm => (<FixedCommentInput isReadOnly={!updateComments} key={cm.id} field={cm.id} fixedComment={cm} />))}
                        </div>
                    </div>
                </div>
                <div className="modal-footer">
                    {!!updateComments ?
                    <>
                        <button disabled={isBusy || !!keys(formState.touched)?.length} className="btn btn-primary btn-outline" onClick={e => {
                            e.preventDefault();
                            onClose && onClose();
                        }} >Close</button>
                        <button disabled={isBusy || !keys(formState.touched)?.length} className="btn btn-primary" onClick={e => {
                            e.preventDefault();
                            formApi.submitForm();
                            }}>Update</button>
                    </>: null}
                </div>
                
            </Modal>)
        }
    </Form> : <LoadingModal header={header} />);
};

const LoadingModal = ({ header }): JSX.Element => {

    return (<Modal header={header} show={true}
        >
        <div className="modal-body">
            <Loading />
        </div>
    </Modal>);
};

export default AsyncFixedComments;
